import axios from 'utils/api';

type DuplicateStructureResponse = {
  structureUniqueId: string;
};

export async function duplicateStructure(
  projectId: number,
  structureUniqueId: string
): Promise<string> {
  const response = await axios.post<DuplicateStructureResponse>(
    'structure/duplicate',
    { projectId, structureUniqueId }
  );
  return response.data.structureUniqueId;
}
